import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const TechLearning: Site = {
  id: 'techlearning',
  logo: 'svg/techlearning.svg',
  label: 'Tech Learning',
  analyticsName: 'techlearning',
  hostname: 'techlearning.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
